<template>
  <div>
    <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px">
      <div class="row">
        <modal :show.sync="modals.viewquotation" class="modal-eprf" centered>
          <b-card class="card text-center" style="
              text-align: center;
              background-color: white;
              box-shadow: none;
            " border-variant="primary" header="QUOTATION REQUEST" header-bg-variant="primary"
            header-text-variant="white">
            <template #header>
              <div class="row">
                <div class="col-lg text-left">
                  <h4 class="mb-0">QUOTATION REQUEST - {{ referenceno }}</h4>
                </div>
                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                  <base-button class="btn-icon btn-cancel btn-round btn-sm">
                    <i style="
                        transform: translate(-50%, -50%);
                        color: white;
                        font-weight: 900;
                        font-size: 12px;
                      " class="tim-icons icon-simple-remove" @click="modals.viewquotation = false"></i>
                  </base-button>
                </div>
              </div>
            </template>
            <div class="col-lg-12">
              <div class="modal-body-scrollable" style="max-height: 70vh; overflow-y: auto">
                <div style="padding: 5px 20px 0px 20px">
                  <div class="row">
                    <div class="col-6">
                      <p
                        style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        Reference No.
                      </p>
                      <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                        {{
                          referenceno }}
                      </p>
                    </div>

                    <div class="col-6">
                      <p
                        style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        Service Location
                      </p>
                      <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                        {{
                          servicelocation }}
                      </p>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-6">
                      <p
                        style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        PIC Name
                      </p>
                      <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                        {{
                          picname
                        }}
                      </p>
                    </div>

                    <div class="col-6">
                      <p
                        style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        PIC Phone No.
                      </p>
                      <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                        {{
                          picphoneno }}
                      </p>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-12">
                      <p
                        style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        Customer Remarks
                      </p>
                      <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                        {{
                          customerremark }}
                      </p>

                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-9">
                      <div>
                        <p
                          style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                          Subject Line
                        </p>
                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                          {{
                            subjectline }}
                        </p>
                      </div>
                    </div>
                    <div class="col-3 text-right" style="margin-top: 2%; ">
                      <base-button type="primary" v-on:click="createQuo()">
                        <i style="color: white; font-size: 18px; font-weight: 900"
                          class="tim-icons icon-cloud-download-93"></i>&nbsp;
                        Print</base-button>
                    </div>
                  </div><br />
                  <el-table :data="allorderitems" :header-cell-style="{
                    background: '#358DCC',
                    border: 'transparent',
                    'font-size': '14px',
                    'font-weight': '400',
                    color: '#FFFFFF',
                  }" :row-style="tableRowClassName">
                    <el-table-column label="No." width="100" align="center">
                      <template slot="header" slot-scope="scope">
                        <div>
                          <span>{{ scope.column.label }}</span>
                        </div>
                      </template>
                      <div slot-scope="scope">
                        <p style="font-size: 14px; color: #707070">
                          {{ scope.row.indexing }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column label="Product" :min-width="150" prop="filename" align="center">
                      <template slot="header" slot-scope="scope">
                        <div>
                          <span>{{ scope.column.label }}</span>
                        </div>
                      </template>
                      <div slot-scope="scope" align="left">
                        <p v-if="scope.row.indexing < allorderitems.length" style="font-size: 14px; color: #707070">
                          {{ scope.row.waste_type.name }}
                          <br />
                          Remark: {{ scope.row.remark }}
                        </p>
                        <p v-else-if="scope.row.waste_type.name == 'GRAND TOTAL'"
                          style="font-size: 14px; color: #000; font-weight: bold">
                          {{ scope.row.waste_type.name }}
                        </p>
                        <p v-else style="font-size: 14px; color: #707070;">
                          {{ scope.row.waste_type.name }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column label="Qty (kg)" :min-width="50" prop="filename" align="center">
                      <template slot="header" slot-scope="scope">
                        <div>
                          <span>{{ scope.column.label }}</span>
                        </div>
                      </template>
                      <div slot-scope="scope" align="center">
                        <p style="font-size: 14px; color: #707070">
                          {{ scope.row.quantity }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column label="Rate (RM/Kg)" :min-width="100" align="center">
                      <div slot-scope="scope">
                        <p style="font-size: 14px; color: #707070">
                          {{ scope.row.rate }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column label="Price (RM)" :min-width="100" align="center">
                      <div slot-scope="scope">
                        <p v-if="scope.row.waste_type.name != 'Transportation rate'"
                          style="font-size: 14px; color: #707070">
                          {{ scope.row.amount }}
                        </p>
                        <p v-if="scope.row.waste_type.name == 'Transportation rate'"
                          style="font-size: 14px; color: #707070">
                          {{ transportrate }}
                        </p>
                      </div>
                    </el-table-column>
                  </el-table>
                  <div class="row">
                    <div class="col-4">

                      <div>
                        <p
                          style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                          Delivery Term
                        </p>
                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                          {{
                            deliveryterm }} {{
                            deliverytermunit }}
                        </p>
                        <br />
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p
                          style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                          Payment Term
                        </p>
                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                          {{
                            paymentterm }} <span style="color: #707070; font-size: 14px;">Days</span>
                        </p>
                        <br />
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p
                          style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                          Validity
                        </p>
                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                          {{
                            validity }} <span style="color: #707070; font-size: 14px;">Days</span>
                        </p>
                        <br />
                      </div>
                    </div>
                  </div>

                  <div>
                    <p
                      style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                      Remarks
                    </p>
                    <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">{{
                      remarks }}
                    </p>
                    <br />
                  </div>

                  <br />

                  <div v-if="pagestatus == 3">
                    <p style="
                      color: #707070;
                      font-size: 15px;
                      font-weight: bold;
                      text-align: left;
                      margin-bottom: -10px;
                    ">
                      Quotation Supporting Document<span style="color: #EC1B23">*</span>
                    </p>
                    <p style="
                      color: #707070;
                      opacity: 0.7;
                      text-align: left;
                      font-size: 14px;
                    ">
                      Please upload PO and Acknowledgement Quotation
                    </p>

                    <div class="row">
                      <div class="col-lg-4 text-left">
                        <div class="fileinput">
                          <label style="
                            font-size: 13px;
                            color: #ffffff;
                            text-transform: capitalize;
                          " for="quo-upload" type="primary" class="btn">
                            Choose File
                          </label>

                          <div class="d-flex justify-content-center spinner" v-if="quoload == true">
                            <circle-8></circle-8>
                          </div>

                          <input accept="application/pdf" id="quo-upload" ref="quo" type="file" name="..." class="valid"
                            :multiple="true" aria-invalid="false" style="display: none"
                            v-on:change="onFileChangeQuoDoc" />
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div v-if="allquotationdocs.length === 0">
                        <p style="
                          color: #707070;
                          opacity: 0.7;
                          text-align: left;
                          font-size: 14px;
                          margin-bottom: -10px;
                        ">
                          No file chosen
                        </p>
                      </div>
                      <div v-for="(item, index) in allquotationdocs" :key="index">
                        <div class="row">
                          <div class="col-lg-1 text-center">
                            <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                          </div>
                          <div class="col-lg-9 text-left">
                            <p style="color: #A5A5A5; font-size: 14px">
                              {{ item.filename }}
                            </p>
                          </div>
                          <div class="col-lg-1 text-center">
                            <a :href="item.fileurl" :download="item.filename">
                              <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                            </a>
                          </div>
                          <div class="col-lg-1 text-center">
                            <i class="tim-icons icon-simple-remove remove-icon" @click="removeQuoDoc(item.fileid)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="pagestatus == 100 && allquotationdocs.length > 0">
                    <p
                      style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                      Quotation Supporting Document
                    </p>

                    <div class="col-lg-12">
                      <div v-if="allquotationdocs.length === 0">
                        <p
                          style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                          No
                          file
                          uploaded.
                        </p>
                      </div>
                      <div v-for="(item, index) in allquotationdocs" :key="index">
                        <div class="row">
                          <div class="col-lg-1 text-center">
                            <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                          </div>
                          <div class="col-lg-10 text-left">
                            <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                          </div>
                          <div class="col-lg-1 text-center">
                            <a :href="item.fileurl" :download="item.filename">
                              <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <div v-if="pagestatus == 3" class="col-lg-12 text-right">
                <base-button @click="modals.disputereason = true" type="cancel">Dispute</base-button>
                <base-button @click="acceptQuotation" :disabled="canapprove" type="primary">Accept</base-button>
              </div>
            </div>
          </b-card>
        </modal>

        <modal :show.sync="modals.viewdeliveryorder" class="modal-eprf" centered>
          <b-card class="card text-center" style="background-color: white; box-shadow: none" border-variant="primary"
            header="ORDER DETAILS - " header-bg-variant="primary" header-text-variant="white">
            <template #header>
              <div class="row">
                <div class="col-lg text-left">
                  <h4 class="mb-0">DELIVERY ORDER - {{ referenceno }}</h4>
                </div>
                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                  <base-button class="btn-icon btn-cancel btn-round btn-sm">
                    <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.viewdeliveryorder = false"></i>
                  </base-button>
                </div>
              </div>
            </template>

            <div class="col-lg-12">
              <div class="modal-body-scrollable" style="max-height: 70vh; overflow-y: auto;">
                <div style="padding: 5px 20px 0px 20px;">
                  <div class="row">
                    <div class="col-6">
                      <p
                        style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        Reference No.
                      </p>
                      <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                        {{
                          referenceno }}
                      </p>
                    </div>

                    <div class="col-6">
                      <p
                        style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        Service Location
                      </p>
                      <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                        {{
                          servicelocation }}
                      </p>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-6">
                      <p
                        style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        PIC Name
                      </p>
                      <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                        {{
                          picname
                        }}
                      </p>
                    </div>

                    <div class="col-6">
                      <p
                        style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        PIC Phone No.
                      </p>
                      <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                        {{
                          picphoneno }}
                      </p>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-12">
                      <p
                        style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        Customer Remarks
                      </p>
                      <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                        {{
                          customerremark }}
                      </p>

                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-9">
                      <div>
                        <p
                          style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                          Subject Line
                        </p>
                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                          {{
                            subjectline }}
                        </p>
                      </div>
                    </div>
                    <div class="col-3 text-right" style="margin-top: 2%; ">
                      <base-button type="primary" v-on:click="createDO()">
                        <i style="color: white; font-size: 18px; font-weight: 900"
                          class="tim-icons icon-cloud-download-93"></i>&nbsp;
                        Print</base-button>
                    </div>
                  </div><br />
                  <el-table :data="allorderitems" :header-cell-style="{
                    background: '#358DCC',
                    border: 'transparent',
                    'font-size': '14px',
                    'font-weight': '400',
                    color: '#FFFFFF',
                  }" :row-style="tableRowClassName">
                    <el-table-column label="No." width="100" align="center">
                      <template slot="header" slot-scope="scope">
                        <div><span>{{ scope.column.label }}</span></div>
                      </template>
                      <div slot-scope="scope">
                        <p style="font-size: 14px; color: #707070">
                          {{ scope.row.indexing }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column label="Product" :min-width="150" prop="filename" align="center">
                      <template slot="header" slot-scope="scope">
                        <div><span>{{ scope.column.label }}</span>
                        </div>
                      </template>
                      <div slot-scope="scope" align="left">
                        <p v-if="scope.row.indexing < allorderitems.length" style="font-size: 14px; color: #707070">
                          {{ scope.row.waste_type.name }}
                          <br />
                          Remark: {{ scope.row.remark }}
                        </p>
                        <p v-else-if="scope.row.waste_type.name == 'GRAND TOTAL'"
                          style="font-size: 14px; color: #000; font-weight: bold">
                          {{ scope.row.waste_type.name }}
                        </p>
                        <p v-else style="font-size: 14px; color: #707070;">
                          {{ scope.row.waste_type.name }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column label="Qty (kg)" :min-width="50" prop="filename" align="center">
                      <template slot="header" slot-scope="scope">
                        <div><span>{{ scope.column.label }}</span>
                        </div>
                      </template>
                      <div slot-scope="scope" align="center">
                        <p style="font-size: 14px; color: #707070">
                          {{ scope.row.quantity }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column label="Rate (RM/Kg)" :min-width="100" align="center">
                      <div slot-scope="scope">
                        <p style="font-size: 14px; color: #707070; margin-right: 16%;">
                          {{ scope.row.rate }}
                        </p>
                      </div>
                      <!-- <div v-else-if="positionid != 4" slot-scope="scope">
                        <input
                          v-if="scope.row.waste_type.name != 'GRAND TOTAL' && scope.row.waste_type.name != 'Transportation rate'"
                          type="number" min="0" step=".01" style="color: #707070; text-align: right;"
                          :class="{ 'custom-input': true }" v-model="scope.row.rate"
                          @change="rateChange(scope.$index)" />
                      </div> -->
                    </el-table-column>
                    <el-table-column label="Price (RM)" :min-width="100" align="center">
                      <div
                        v-if="scope.row.waste_type.name != 'Transportation rate' && scope.row.waste_type.name != 'GRAND TOTAL'"
                        slot-scope="scope">
                        <p style="text-align: right; font-size: 14px; color: #707070; margin-right: 16%;">
                          {{ scope.row.amount }}
                        </p>
                      </div>
                      <div v-else-if="scope.row.waste_type.name == 'Transportation rate'">
                        <!-- <p v-if="positionid == 4"
                          style="text-align: right; font-size: 14px; color: #707070; margin-right: 16%;">
                          {{ transportrate }}
                        </p> -->
                        <p style=" font-size: 14px; color: #707070; text-align: right; margin-right: 16%;">
                          {{ transportrate }}
                        </p>
                        <!-- <input v-else-if="positionid != 4 && pagestatus != 100" slot-scope="scope" type="number" min="0"
                          step=".01" style="color: #707070; text-align: right;" :class="{ 'custom-input': true }"
                          @input="transportrate = transportrate < 0 ? 0 : transportrate" v-model="transportrate" /> -->
                      </div>
                      <div v-else-if="scope.row.waste_type.name == 'GRAND TOTAL'" slot-scope="scope">
                        <p style="text-align: right; margin-right: 16%; font-size: 14px; color: #707070">
                          {{ scope.row.amount }}
                        </p>
                      </div>
                    </el-table-column>
                  </el-table>
                  <div class="row">
                    <div class="col-4">

                      <div>
                        <p
                          style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                          Delivery Term
                        </p>
                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                          {{
                            deliveryterm }} {{
                            deliverytermunit }}
                        </p>
                        <br />
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p
                          style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                          Payment Term
                        </p>
                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                          {{
                            paymentterm }} <span style="color: #707070; font-size: 14px;">Days</span>
                        </p>
                        <br />
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p
                          style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                          Validity
                        </p>
                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                          {{
                            validity }} <span style="color: #707070; font-size: 14px;">Days</span>
                        </p>
                        <br />
                      </div>
                    </div>
                  </div>

                  <div>
                    <p
                      style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                      Remarks
                    </p>
                    <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">{{
                      remarks }}
                    </p>
                    <br />
                  </div>

                  <p
                    style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                    Quotation Supporting Document
                  </p>

                  <div class="col-lg-12">
                    <div v-if="allquotationdocs.length === 0">
                      <p
                        style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        No
                        file
                        uploaded.
                      </p>
                    </div>
                    <div v-for="(item, index) in allquotationdocs" :key="index">
                      <div class="row">
                        <div class="col-lg-1 text-center">
                          <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                        </div>
                        <div class="col-lg-10 text-left">
                          <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                        </div>
                        <div class="col-lg-1 text-center">
                          <a :href="item.fileurl" :download="item.filename">
                            <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <p
                    style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                    Proforma Invoice
                  </p>
                  <div class="col-lg-12">
                    <div v-if="allproformafile.length === 0">
                      <p
                        style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        No
                        file
                        uploaded.
                      </p>
                    </div>
                    <div v-for="(item, index) in allproformafile" :key="index">
                      <div class="row">
                        <div class="col-lg-1 text-center">
                          <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                        </div>
                        <div class="col-lg-10 text-left">
                          <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                        </div>
                        <div class="col-lg-1 text-center">
                          <a :href="item.fileurl" :download="item.filename">
                            <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <p
                    style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                    Payment Receipt
                  </p>
                  <div class="col-lg-12">
                    <div v-if="allpaymentproof.length === 0">
                      <p
                        style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                        No
                        file
                        uploaded.
                      </p>
                    </div>
                    <div v-for="(item, index) in allpaymentproof" :key="index">
                      <div class="row">
                        <div class="col-lg-1 text-center">
                          <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                        </div>
                        <div class="col-lg-10 text-left">
                          <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                        </div>
                        <div class="col-lg-1 text-center">
                          <a :href="item.fileurl" :download="item.filename">
                            <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <br />
            </div>
          </b-card>
        </modal>

        <modal :show.sync="modals.viewother" class="modal-eprf" centered>
          <b-card class="card text-center" style="background-color: white; box-shadow: none" border-variant="primary"
            header="ORDER DETAILS - " header-bg-variant="primary" header-text-variant="white">
            <template #header>
              <div class="row">
                <div class="col-lg text-left">
                  <h4 class="mb-0">ORDER DETAILS - {{ referenceno }}</h4>
                </div>
                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                  <base-button class="btn-icon btn-cancel btn-round btn-sm">
                    <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.viewother = false"></i>
                  </base-button>
                </div>
              </div>
            </template>

            <div class="col-lg-12">
              <el-table :data="allorderitems" :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }" :row-style="tableRowClassName">
                <el-table-column width="100" align="center">
                  <template slot="header" slot-scope="scope">
                    <div><span>{{ scope.column.label }}</span></div>
                  </template>
                  <div slot-scope="scope">
                    <p style="font-size: 14px; color: #707070">
                      {{ scope.$index + 1 }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="Item" :min-width="150" prop="filename" align="left">
                  <template slot="header" slot-scope="scope">
                    <div><span>{{ scope.column.label }}</span>
                    </div>
                  </template>
                  <div slot-scope="scope" align="left">
                    <p style="font-size: 14px; color: #707070">
                      {{ scope.row.waste_type.name }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="Quantity" :min-width="50" prop="filename" align="center">
                  <template slot="header" slot-scope="scope">
                    <div><span>{{ scope.column.label }}</span>
                    </div>
                  </template>
                  <div slot-scope="scope" align="center">
                    <p style="font-size: 14px; color: #707070">
                      {{ scope.row.quantity }}
                    </p>
                  </div>
                </el-table-column>
              </el-table>

              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                      Status
                    </p>
                    <p style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                      {{ statusname }}
                    </p>
                  </div>
                </div>
              </div>

              <br />
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                      Pickup
                      Location
                    </p>
                    <p style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                      {{
                        servicelocation
                      }}
                    </p>
                  </div>
                </div>
              </div>

              <br v-if="customerremark != '-'" />
              <div v-if="customerremark != '-'" class="col-lg-12">
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                      Customer Remark
                    </p>
                    <p style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                      {{
                        customerremark
                      }}
                    </p>
                  </div>
                </div>
              </div>

              <br />
              <!-- 99 quote disputed-->
              <!-- 4 quotation disputed -->
              <div v-if="currentstatus == 4" class="col-lg-12">
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                      Quotation Disputed Reason <span>
                        <i @click="modals.viewlog = true" style="margin-top: -5px;"
                          class="tim-icons icon-chat-33 download-icon"></i>
                      </span>
                    </p>
                    <p style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                      {{
                        quotationdisputedreason
                      }}
                    </p>
                  </div>
                </div>
                <br />
                <p style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                  Quotation Dispute Document
                </p>

                <div class="col-lg-12">
                  <div v-if="alldisputedocsmanage.length === 0">
                    <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                      No
                      file
                      uploaded.
                    </p>
                  </div>
                  <div v-for="(item, index) in alldisputedocsmanage" :key="index">
                    <div class="row">
                      <div class="col-lg-1 text-center">
                        <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                      </div>
                      <div class="col-lg-10 text-left">
                        <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                      </div>
                      <div class="col-lg-1 text-center">
                        <a :href="item.fileurl" :download="item.filename">
                          <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="currentstatus == 99" class="col-lg-12">
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                      Quote Disputed Reason
                    </p>
                    <p style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                      {{
                        quotedisputedreason
                      }}
                    </p>
                  </div>
                </div>
                <br />
                <p style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                  Quote Dispute Document
                </p>

                <div class="col-lg-12">
                  <div v-if="allquotedisputedocs.length === 0">
                    <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                      No
                      file
                      uploaded.
                    </p>
                  </div>
                  <div v-for="(item, index) in allquotedisputedocs" :key="index">
                    <div class="row">
                      <div class="col-lg-1 text-center">
                        <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                      </div>
                      <div class="col-lg-10 text-left">
                        <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                      </div>
                      <div class="col-lg-1 text-center">
                        <a :href="item.fileurl" :download="item.filename">
                          <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <br />
            </div>
          </b-card>
        </modal>

        <modal :show.sync="modals.viewlog" class="modal-eprf" centered>
          <b-card class="card text-center" style="background-color: white; box-shadow: none" border-variant="primary"
            header="DISPUTE LOG" header-bg-variant="primary" header-text-variant="white">
            <template #header>
              <div class="row">
                <div class="col-lg text-left">
                  <h4 class="mb-0">DISPUTE LOG</h4>
                </div>
                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                  <base-button class="btn-icon btn-cancel btn-round btn-sm">
                    <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.viewlog = false"></i>
                  </base-button>
                </div>
              </div>
            </template>

            <div class="col-lg-12">
              <el-table :data="logquotationdisputed" :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }" :row-style="tableRowClassName">
                <el-table-column width="100" align="center">
                  <template slot="header" slot-scope="scope">
                    <div><span>{{ scope.column.label }}</span></div>
                  </template>
                  <div slot-scope="scope">
                    <p style="font-size: 14px; color: #707070">
                      {{ scope.$index + 1 }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="Reason" :min-width="150" prop="remark" align="center">
                </el-table-column>
                <el-table-column label="Date Created" :min-width="50" prop="date" align="center">
                </el-table-column>
                <el-table-column label="PIC" :min-width="50" prop="username" align="center">
                </el-table-column>
              </el-table>
            </div>
          </b-card>
        </modal>

        <modal :show.sync="modals.viewproforma" class="modal-eprf" centered>
          <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
            header="PAYMENT RECEIPT" header-bg-variant="primary" header-text-variant="white">
            <template #header>
              <div class="row">
                <div class="col-lg text-left">
                  <h4 class="mb-0">PAYMENT RECEIPT</h4>
                </div>
                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                  <base-button class="btn-icon btn-cancel btn-round btn-sm">
                    <i style="
                        transform: translate(-50%, -50%);
                        color: white;
                        font-weight: 900;
                        font-size: 12px;
                      " class="tim-icons icon-simple-remove" @click="modals.viewproforma = false"></i>
                  </base-button>
                </div>
              </div>
            </template>
            <div class="col-lg-12">
              <div class="modal-body-scrollable" style="max-height: 70vh; overflow-y: auto;">

                <div style="padding: 5px 20px 0px 20px">
                  <p style="
                    color: #707070;
                    opacity: 0.7;
                    text-align: left;
                    font-size: 14px;
                  ">
                    Quotation document
                  </p>

                  <div class="col-lg-12">
                    <div v-if="allquotationdocs.length === 0">
                      <p style="
                        color: #707070;
                        opacity: 0.7;
                        text-align: left;
                        font-size: 14px;
                      ">
                        No file chosen
                      </p>
                    </div>
                    <div v-for="(item, index) in allquotationdocs" :key="index">
                      <div class="row">
                        <div class="col-lg-1 text-center">
                          <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                        </div>
                        <div class="col-lg-10 text-left">
                          <p style="color: #A5A5A5; font-size: 14px">
                            {{ item.filename }}
                          </p>
                        </div>
                        <div class="col-lg-1 text-center">
                          <a :href="item.fileurl" :download="item.filename">
                            <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="allproformafile.length !== 0">
                    <br />
                    <p style="
                      color: #707070;
                      opacity: 0.7;
                      text-align: left;
                      font-size: 14px;
                      margin-bottom: -10px;
                    ">
                      Proforma Invoice
                    </p>
                    <div class="col-lg-12">
                      <div v-if="allproformafile.length === 0">
                        <p style="
                          color: #707070;
                          opacity: 0.7;
                          text-align: left;
                          font-size: 14px;
                          margin-bottom: -10px;
                        ">
                          No file chosen
                        </p>
                      </div>
                      <div v-for="(item, index) in allproformafile" :key="index">
                        <div class="row">
                          <div class="col-lg-1 text-center">
                            <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                          </div>
                          <div class="col-lg-10 text-left">
                            <p style="color: #A5A5A5; font-size: 14px">
                              {{ item.filename }}
                            </p>
                          </div>
                          <div class="col-lg-1 text-center">
                            <a :href="item.fileurl" :download="item.filename">
                              <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <br />

                    <p style="
                      color: #707070;
                      font-size: 15px;
                      font-weight: bold;
                      text-align: left;
                      margin-bottom: -10px;
                    ">
                      Upload Payment Receipt<span style="color: #EC1B23">*</span>
                    </p>
                    <p style="
                      color: #707070;
                      opacity: 0.7;
                      text-align: left;
                      font-size: 14px;
                    ">
                      Please upload payment receipt
                    </p>

                    <div class="row">
                      <div class="col-lg-4 text-left">
                        <div class="fileinput">
                          <label style="
                            font-size: 13px;
                            color: #ffffff;
                            text-transform: capitalize;
                          " for="proof-upload" type="primary" class="btn">
                            Choose File
                          </label>

                          <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                            <circle-8></circle-8>
                          </div>

                          <input accept="application/pdf" id="proof-upload" ref="proof" type="file" name="..."
                            class="valid" :multiple="true" aria-invalid="false" style="display: none"
                            v-on:change="onFileChangeProof" />
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div v-if="allpaymentproof.length === 0">
                        <p style="
                          color: #707070;
                          opacity: 0.7;
                          text-align: left;
                          font-size: 14px;
                          margin-bottom: -10px;
                        ">
                          No file chosen
                        </p>
                      </div>
                      <div v-for="(item, index) in allpaymentproof" :key="index">
                        <div class="row">
                          <div class="col-lg-1 text-center">
                            <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                          </div>
                          <div class="col-lg-9 text-left">
                            <p style="color: #A5A5A5; font-size: 14px">
                              {{ item.filename }}
                            </p>
                          </div>
                          <div class="col-lg-1 text-center">
                            <a :href="item.fileurl" :download="item.filename">
                              <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                            </a>
                          </div>
                          <div class="col-lg-1 text-center">
                            <i class="tim-icons icon-simple-remove remove-icon" @click="removeProof(item.fileid)"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div v-else>
                    <br />
                    <p style="
                      color: #707070;
                      opacity: 0.7;
                      text-align: left;
                      font-size: 14px;
                      margin-bottom: -10px;
                    ">
                      Waiting for proforma invoice...
                    </p>
                    <br />
                  </div>
                </div>
                <br />
                <div class="col-lg-12 text-right">
                  <base-button type="primary" @click="submitProforma()" :disabled="cansubmit">Submit</base-button>
                </div>
              </div>
            </div>
          </b-card>
        </modal>

        <modal :show.sync="modals.viewrejectreason" class="modal-eprf" centered>
          <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
            header="REASON FOR DISPUTE" header-bg-variant="primary" header-text-variant="white">
            <template #header>
              <div class="row">
                <div class="col-lg text-left"></div>
                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                  <base-button class="btn-icon btn-cancel btn-round btn-sm">
                    <i style="
                        transform: translate(-50%, -50%);
                        color: white;
                        font-weight: 900;
                        font-size: 12px;
                      " class="tim-icons icon-simple-remove" @click="modals.viewrejectreason = false"></i>
                  </base-button>
                </div>
              </div>
            </template>

            <div class="row">
              <div class="col-lg-12">
                <textarea type="textarea" placeholder="Reason for dispution..." v-model="reason"
                  :class="{ textarea: true }" disabled></textarea>
              </div>
            </div>
          </b-card>
        </modal>

        <modal :show.sync="modals.disputereason" class="modal-eprf" centered>
          <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
            header="REASON FOR DISPUTE" header-bg-variant="primary" header-text-variant="white">
            <template #header>
              <div class="row">
                <div class="col-lg text-left">
                  <h4 class="mb-0">REASON FOR DISPUTE</h4>
                </div>
                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                  <base-button class="btn-icon btn-cancel btn-round btn-sm">
                    <i style="
                        transform: translate(-50%, -50%);
                        color: white;
                        font-weight: 900;
                        font-size: 12px;
                      " class="tim-icons icon-simple-remove" @click="modals.disputereason = false"></i>
                  </base-button>
                </div>
              </div>
            </template>

            <div class="row">
              <div class="col-lg-12">
                <textarea style="border: 1px solid #aaa" type="textarea" placeholder="Reason for dispute quotation..."
                  v-model="reason" :class="{ textarea: true }"></textarea>
              </div>
            </div>

            <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
              Dispute document
            </p>

            <div class="col-lg-12">
              <div v-if="alldisputedocsmanage.length === 0">
                <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                  No
                  file
                  chosen
                </p>
              </div>
              <div v-else-if="alldisputedocsmanage.length >= 1" v-for="(item, index) in alldisputedocsmanage"
                :key="index">
                <div class="row">
                  <div class="col-lg-1 text-center">
                    <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                  </div>
                  <div class="col-lg-9 text-left">
                    <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                  </div>
                  <div class="col-lg-1 text-center">
                    <a :href="item.fileurl" :download="item.filename">
                      <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                    </a>
                  </div>
                  <div class="col-lg-1 text-center">
                    <i style="
                            cursor: pointer;
                    color: #FF0000;
                    font-weight: 900;
                    font-size: 20px;
                    margin-top: 16px;
                  " class="tim-icons icon-simple-remove" @click="removeDisputedocsManagement(item.fileid)"></i>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-lg-1">
                <div class="fileinput">
                  <label style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                " for="file-upload" type="primary" class="btn">
                    Upload
                  </label>

                  <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                    <circle-8></circle-8>
                  </div>

                  <input accept="application/pdf" id="file-upload" ref="disputedoc" type="file" name="..." class="valid"
                    :multiple="true" aria-invalid="false" style="display: none"
                    v-on:change="onFileChangeDisputedocsManagement" />
                </div>
              </div>

              <div class="col-lg"></div>

              <div class="col-lg-4 text-right">
                <base-button type="primary" :disabled="candispute" v-on:click="disputeQuotation()">Submit</base-button>

              </div>
            </div>
          </b-card>
        </modal>

        <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />
        <StatusModal :show.sync="modals.removeModal" :message="modal.remove" :title="modal.removeTitle" />
        <StatusModal :show.sync="modals.removeFailedModal" :message="modal.removeFailed" :title="modal.removeTitle" />

        <div class="col-lg-6 text-left">
          <base-button type="primary" v-on:click="gobrowse()">
            Purchase Products
          </base-button>
          &nbsp;
          <el-select placeholder="Select status" v-model="selects.status" @change="getData()" filterable>
            <el-option v-for="option in selects.statuses" class="select-info custom-option" :value="option.value"
              :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>
        <div class="col-lg"></div>
        <div class="col-lg-2">
          <el-input type="search" class="mb-3 search-input" prefix-icon="el-icon-search"
            placeholder="Search Ref No, Comp..." v-model="search" aria-controls="datatables"></el-input>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <card class="card-eprf">
            <div id="tableku" v-if="!load">
              <el-table :data="queriedData" style="width: 100%; color: #A5A5A5" height="700" :header-cell-style="{
                background: 'transparent',
                color: 'black',
              }" class="custom-table" @row-click="clickRow" :row-class-name="rowHover">
                <el-table-column :min-width="50" align="center" prop="index" label="NO">
                </el-table-column>
                <el-table-column :min-width="150" align="center" prop="refno" label="REFERENCE NO">
                  <template slot-scope="{ row }">
                    <p class="job-no-title" style="color: #358CCB">
                      {{ row.refno }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column :min-width="150" align="center" prop="picname" label="PIC NAME">
                </el-table-column>
                <el-table-column :min-width="150" sortable align="center" prop="requestdate" label="REQUEST DATE">
                  <template slot-scope="{row}">
                    {{ moment(row.requestdate).format("DD MMM YYYY") }}
                  </template>
                </el-table-column>
                <el-table-column :min-width="150" align="center" prop="status" label="STATUS">
                  <template slot-scope="{ row }">
                    <p :style="{ color: row.statuscolour }" class="statusview">
                      {{ row.status }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column :min-width="150" align="center" prop="deliverytype" label="DELIVERY TYPE">
                </el-table-column>
                <el-table-column :min-width="300" align="center" prop="remarks" label="REMARKS">
                  <template slot-scope="{ row }">
                    <p style="color: #A5A5A5; text-align: center;" v-if="!row.remarks || row.remarks.trim() === ''">
                      -
                    </p>
                    <p style="color: #A5A5A5; text-align: center" v-else>
                      {{ row.remarks }}
                    </p>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  v-if="accessid != 2"
                  :min-width="100"
                  align="center"
                  prop="edit"
                  label="EDIT"
                >
                  <div slot-scope="{ row }">
                    <i
                      style="
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        color: #A5A5A5;
                        font-size: 15px;
                        font-weight: 900;
                        cursor: pointer;
                      "
                      @click="getEdit(row.id, 'edit')"
                      class="tim-icons icon-pencil"
                    ></i>
                  </div>
                </el-table-column>
                <el-table-column
                  v-for="column in joblist"
                  :key="column.label"
                  :prop="column.prop"
                  :label="column.label"
                  align="center"
                  :min-width="200"
                >
                </el-table-column> -->
                <!-- <el-table-column
                  :min-width="200"
                  align="center"
                  prop="delete"
                  label="DELETE"
                >
                  <template slot-scope="scope">
                    <i
                      style="
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        color: #EC1B23;
                        font-size: 15px;
                        font-weight: 900;
                        cursor: pointer;
                      "
                      @click="getDeleteRow(scope.$index)"
                      class="tim-icons icon-trash-simple"
                    ></i>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
            <div class="d-flex justify-content-center spinner" v-else>
              <circle-8></circle-8>
            </div>
          </card>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <el-select v-model="pagination.perPage" placeholder="Per page">
              <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
                :value="item"></el-option>
            </el-select>

            <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
              :per-page="pagination.perPage" :total="pagination.total"></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import {
  Modal,
  ImageUpload,
  BasePagination,
  BaseSwitch,
} from "../../../../src/components";
import moment from "moment";
import Fuse from "fuse.js";
import { debounce } from "src/util/debounce";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";
import { getStorage } from "../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";

export default {
  name: "LandRequest",

  components: {
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
    BCard,
    StatusModal,
  },

  data() {
    return {
      companyname: '-',
      companyphoneno: '-',
      companyaddress: '',
      companyemail: '-',
      pdftable: [],
      quotationdisputedreason: '',
      logquotationdisputed: [],
      quotedisputedreason: '',
      positionid: 0,
      pagestatus: 0,
      statusname: '-',
      proof: null,
      roleid: 0,
      path: "",
      currentsaleid: "",
      currentstatus: "",
      modal: modal,

      allquotationdocs: [],
      allpaymentproof: [],
      allproformafile: [],
      alldisputedocsmanage: [],
      allquotedisputedocs: [],

      uploadload: false,

      quoload: false,

      proposedate: "20/09/2020",
      pickupdate: "12/10/2021",
      statuspickupdate: false,
      pickuplocation: "Cyberjaya",
      reason: "",
      newdate: "",
      modals: {
        viewlog: false,
        rejectdate: false,
        disputereason: false,
        viewrejectreason: false,
        viewquotation: false,
        viewdeliveryorder: false,
        viewproforma: false,
        viewother: false,
        successModal: false,
        removeModal: false,
        removeFailedModal: false,
      },
      transportrate: 0,
      referenceno: "",
      subjectline: "",
      customer: "-",
      picname: "-",
      picphoneno: "-",
      picemail: '-',
      servicelocation: "-",
      customerremark: "",
      deliveryterm: "",
      deliverytermunit: "",
      paymentterm: "",
      validity: "",
      remarks: "",

      wastejobid: 0,

      selectedFileName: "",
      allfilename: [],
      allorderitems: [
        {
          orderid: "2bcc1e04-c002-443c-86b3-4ec76d9f4c22",
          quantity: 9,
          rate: 10.3,
          rate_cent: 0,
          remark: "ko",
          waste_type: {
            waste_type_id: 18,
            name: "Category Y substance",
          },
        },
        {
          orderid: "53d4642a-0e63-4d00-9176-b031e2df7995",
          quantity: 9,
          rate: 90.8,
          rate_cent: 0,
          remark: "ok",
          waste_type: {
            waste_type_id: 11,
            name: "Oily bilge water",
          },
        },
      ],
      tableDatas: [
        {
          saleid: "26a55966-5f41-48b4-b727-9d82fac7fee2",
          refno: "L-WCOA",
          requestdate: "31-08-2023",
          status: "Completed",
          collectiondate: "31-08-2023",
          remarks: "",
        },
        {
          saleid: "26a55966-5f41-48b4-b727-9d82fac7fee2",
          refno: "L-WCOB",
          requestdate: "31-08-2023",
          status: "Quote Requested",
          collectiondate: "31-08-2023",
          remarks: "woi",
        },
        {
          saleid: "26a55966-5f41-48b4-b727-9d82fac7fee2",
          refno: "L-WCOC",
          requestdate: "31-08-2023",
          status: "Ready for pickup",
          collectiondate: "31-08-2023",
          remarks: "",
        },
        {
          saleid: "26a55966-5f41-48b4-b727-9d82fac7fee2",
          refno: "L-WCOD",
          requestdate: "31-08-2023",
          status: "Preparing Order",
          collectiondate: "31-08-2023",
          remarks: "woi",
        },
        {
          saleid: "26a55966-5f41-48b4-b727-9d82fac7fee2",
          refno: "L-WCOA",
          requestdate: "31-08-2023",
          status: "Review Quotation",
          collectiondate: "31-08-2023",
          remarks: "woi",
        },
        {
          saleid: "26a55966-5f41-48b4-b727-9d82fac7fee2",
          refno: "L-WCOA",
          requestdate: "31-08-2023",
          status: "Download Invoice",
          collectiondate: "31-08-2023",
          remarks: "woi",
        },
        {
          saleid: "26a55966-5f41-48b4-b727-9d82fac7fee2",
          refno: "L-WCON",
          requestdate: "31-08-2023",
          status: "Proforma Invoice Ready",
          collectiondate: "31-08-2023",
          remarks: "woi",
        },
      ],
      load: false,
      jobnum: "",

      refno: [
        {
          prop: "refno",
          label: "REFERENCE NO",
        },
      ],

      selects: {
        assigner: "",
        assigners: [
          { value: "00", label: "All" },
          { value: "01", label: "Yahya Abd Rahman" },
          { value: "02", label: "Ikhwan Ayub" },
          { value: "03", label: "Haziq Haikal" },
        ],

        type: "",
        types: [
          { value: "00", label: "All" },
          { value: "01", label: "Waste" },
          { value: "02", label: "Product" },
        ],
        status: "",
        statuses: [],
      },

      temp: [
      ],
      search: '',
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 30, 50],
        total: 0,
      },
    };
  },
  methods: {
    async getPDF() {
      this.pdftable = [];

      await this.$http
        .get(":10001/api/v1/shop/quote/" + this.currentsaleid)
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log('quotation', response)

            let ratee;
            let estamtt;
            let amt;
            let amountt = 0;
            let totalamount = 0;

            let formatter = new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

            for (var i = 0; i < response.order.length; i++) {
              ratee = formatter.format(response.order[i].rate);
              estamtt = response.order[i].quantity;
              amt = ratee * estamtt;
              totalamount += amt;
              let obj = {
                no: i + 1,
                desc:
                  response.order[i].waste_type.name,
                rate: formatter.format(ratee),
                estamt:
                  response.order[i].quantity,
                amt: amt.toFixed(2),
              };
              amountt += amt;
              this.pdftable.push(obj);
            }

            let transport = {
              no: '',
              desc: 'Tranportation Rate',
              rate: '',
              estamt: '',
              amt: this.transportrate,
            };

            totalamount += response.transport_rate;

            this.pdftable.push(transport);

            let grandtotal = {
              no: '',
              desc: 'Grand Total',
              rate: '',
              estamt: '',
              amt: formatter.format(totalamount),
            };

            this.pdftable.push(grandtotal);



          }
        });
    },
    async createDO() {
      await this.getPDF();
      let doc = jsPDF({
        orientation: "potrait",
      });

      const logo = new Image();
      logo.src = require("@/assets/img/afesnew.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      const sign = new Image();
      sign.src = require("@/assets/img/autograph.png");
      sign.onload = () => {
        this.options = Object.assign({}, this.options, {
          sign: {
            sign,
          },
        });
      };

      const data = this.pdftable;

      const columns = [
        "No.",
        "\t\t\t\t\tProduct",
        "Qty (Kg)",
        "Rate (RM/Kg)",
        "Price (RM)"
      ];

      const rows = data.map((obj) => [
        obj.no,
        obj.desc,
        obj.estamt,
        obj.rate,
        obj.amt,
      ]);

      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      );

      doc.setFontSize(21);
      doc.setFontStyle("bold");
      doc.text("DELIVERY ORDER", 15, 25);
      doc.setFontSize(11);

      doc.setLineWidth(0.3);
      doc.line(10, 40, doc.internal.pageSize.getWidth() - 10, 40);

      doc.setFontStyle("bold");

      doc.text(this.picname, 15, 55);

      doc.setFontStyle("normal");

      var companyAddress = this.companyaddress;
      var maxCharactersPerLine = 25;

      function splitTextIntoLines(text, maxLength) {
        var lines = [];
        while (text.length > maxLength) {
          var line = text.substring(0, maxLength);
          var lastSpace = line.lastIndexOf(" ");
          if (lastSpace !== -1) {
            lines.push(line.substring(0, lastSpace));
            text = text.substring(lastSpace + 1);
          } else {
            lines.push(line);
            text = text.substring(maxLength);
          }
        }
        lines.push(text);
        return lines;
      }

      var addressLines = splitTextIntoLines(
        companyAddress,
        maxCharactersPerLine
      );

      for (var i = 0; i < addressLines.length; i++) {
        var yPos = 60 + i * 5;
        doc.text(addressLines[i], 15, yPos);
      }

      doc.setFontStyle("bold");
      doc.text("Ref No.", 130, 55);
      doc.text("Date", 130, 60);
      doc.setFontStyle("normal");

      doc.text(":", 150, 55);
      doc.text(":", 150, 60);

      doc.text(this.referenceno, 152, 55);
      doc.text(moment().format("DD-MM-YYYY"), 152, 60);

      doc.text("Tel No. : " + this.picphoneno, 15, 80);
      doc.text("Email : " + this.companyemail, 130, 80);
      doc.setFontStyle("bold");

      doc.text("Attention", 15, 90);
      doc.text("Subject", 15, 95);

      doc.text(":", 35, 90);
      doc.text(":", 35, 95);

      doc.text(this.picname, 40, 90);
      doc.text(this.subjectline, 40, 95);

      doc.setFontStyle("normal");

      doc.text("Dear Sir/Madam,", 15, 105);
      doc.text(
        "We appreciate this opportunity to offer you our delivery order as follows:",
        15,
        115
      );

      const table = doc.autoTable({
        head: [columns],
        columnStyles: {
          0: {
            halign: "center",
            cellWidth: 10,
          },
          1: {
            // columnWidth: 100,
          },
          2: {
            halign: "center",
            cellWidth: 20,
          },
          3: {
            halign: "center",
            cellWidth: 27,
          },
          4: {
            halign: "center",
            cellWidth: 23,
          },
        },
        styles: {
          lineWidth: 0.1, // Set the border line width
          lineColor: [0, 0, 0], // Set the border color
        },
        theme: "plain",
        body: rows,
        startY: 120,
      });

      const tableHeight = table.autoTable.previous.finalY;

      doc.text("Terms & Conditions", 15, tableHeight + 10);
      doc.text("Terms of Delivery", 15, tableHeight + 15);
      doc.text("Terms of Payment", 15, tableHeight + 20);
      doc.text("Validity", 15, tableHeight + 25);
      doc.text("Remarks", 15, tableHeight + 30);

      doc.text(":", 55, tableHeight + 15);
      doc.text(":", 55, tableHeight + 20);
      doc.text(":", 55, tableHeight + 25);
      doc.text(": ", 55, tableHeight + 30);

      doc.text(
        "a) Payment for completed services to be paid and made payable to",
        60,
        tableHeight + 30
      );
      doc.setFontStyle("bold");

      doc.text(
        "ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD.",
        60,
        tableHeight + 35
      );
      doc.setFontStyle("normal");
      doc.text(
        "b) All price(s) quoted is inclusive of Sales and Services Tax (SST), customs",
        60,
        tableHeight + 40
      );
      doc.text(
        "clerance or taxes and customs agent fees (if any).",
        60,
        tableHeight + 45
      );

      doc.text(
        this.deliveryterm + " " + this.deliverytermunit,
        60,
        tableHeight + 15
      );
      doc.text(this.paymentterm + " Days", 60, tableHeight + 20);
      doc.text(this.validity + " Days", 60, tableHeight + 25);
      var text = this.remarks;
      var x = 60;
      var y = tableHeight + 50;

      var lines = doc.splitTextToSize(
        text,
        doc.internal.pageSize.width - x * 1.3
      );

      if (this.remarks != "" && this.remarks != null) {
        doc.text("c) " + lines[0], x, y);
      }
      for (var i = 1; i < lines.length; i++) {
        if (y + 50 > doc.internal.pageSize.getHeight() - 20) {
          doc.addPage();
          y = 25;
        }
        doc.text(lines[i], x, y + 5);
        y += 5;
      }

      var finalYOfText = y;

      doc.text(
        "If you agree with the quotation, please sign in below and send/email it to us as attached as soon as",
        15,
        finalYOfText + 10
      );

      doc.text("possible for further arrangement.", 15, finalYOfText + 15);
      doc.text(
        "Should you need any clarification, please contact " +
        this.companyname +
        " at " +
        this.companyphoneno,
        15,
        finalYOfText + 20
      );
      doc.setFontStyle("bold");

      doc.text(
        "for ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD",
        15,
        finalYOfText + 30
      );
      doc.setFontStyle("normal");

      doc.text(
        "Previously known as DRB-HICOM ENVIRONMENTAL SERVICES SDN BHD",
        15,
        finalYOfText + 35
      );

      doc.setFontStyle("bold");

      doc.addImage(
        sign,
        "PNG",
        doc.internal.pageSize.getWidth() - 195,
        finalYOfText + 40,
        30,
        15
      );

      doc.text("NAZIRA MAHAYUDDIN", 15, finalYOfText + 60);

      doc.setFontStyle("normal");
      doc.text("Senior Manager,", 15, finalYOfText + 65);
      doc.text("Marine Waste Management,", 15, finalYOfText + 70);
      doc.text(
        "Environmental Technology & Solutions Department",
        15,
        finalYOfText + 75
      );

      doc.save("Delivery Order.pdf");

      console.log("pdf createdd");
    },
    async createQuo() {
      await this.getPDF();
      let doc = jsPDF({
        orientation: "potrait",
      });

      const logo = new Image();
      logo.src = require("@/assets/img/afesnew.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      const sign = new Image();
      sign.src = require("@/assets/img/autograph.png");
      sign.onload = () => {
        this.options = Object.assign({}, this.options, {
          sign: {
            sign,
          },
        });
      };

      const data = this.pdftable;

      const columns = [
        "No.",
        "\t\t\t\t\tProduct",
        "Qty (Kg)",
        "Rate (RM/Kg)",
        "Price (RM)"
      ];

      const rows = data.map((obj) => [
        obj.no,
        obj.desc,
        obj.estamt,
        obj.rate,
        obj.amt,
      ]);

      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      );

      doc.setFontSize(21);
      doc.setFontStyle("bold");
      doc.text("QUOTATION", 15, 25);
      doc.setFontSize(11);

      doc.setLineWidth(0.3);
      doc.line(10, 40, doc.internal.pageSize.getWidth() - 10, 40);

      doc.setFontStyle("bold");

      doc.text(this.picname, 15, 55);

      doc.setFontStyle("normal");

      var companyAddress = this.companyaddress;
      var maxCharactersPerLine = 25;

      function splitTextIntoLines(text, maxLength) {
        var lines = [];
        while (text.length > maxLength) {
          var line = text.substring(0, maxLength);
          var lastSpace = line.lastIndexOf(" ");
          if (lastSpace !== -1) {
            lines.push(line.substring(0, lastSpace));
            text = text.substring(lastSpace + 1);
          } else {
            lines.push(line);
            text = text.substring(maxLength);
          }
        }
        lines.push(text);
        return lines;
      }

      var addressLines = splitTextIntoLines(
        companyAddress,
        maxCharactersPerLine
      );

      for (var i = 0; i < addressLines.length; i++) {
        var yPos = 60 + i * 5;
        doc.text(addressLines[i], 15, yPos);
      }

      doc.setFontStyle("bold");
      doc.text("Ref No.", 130, 55);
      doc.text("Date", 130, 60);
      doc.setFontStyle("normal");

      doc.text(":", 150, 55);
      doc.text(":", 150, 60);

      doc.text(this.referenceno, 152, 55);
      doc.text(moment().format("DD-MM-YYYY"), 152, 60);

      doc.text("Tel No. : " + this.picphoneno, 15, 80);
      doc.text("Email : " + this.companyemail, 130, 80);
      doc.setFontStyle("bold");

      doc.text("Attention", 15, 90);
      doc.text("Subject", 15, 95);

      doc.text(":", 35, 90);
      doc.text(":", 35, 95);

      doc.text(this.picname, 40, 90);
      doc.text(this.subjectline, 40, 95);

      doc.setFontStyle("normal");

      doc.text("Dear Sir/Madam,", 15, 105);
      doc.text(
        "We appreciate this opportunity to offer you our quotation as follows:",
        15,
        115
      );

      const table = doc.autoTable({
        head: [columns],
        columnStyles: {
          0: {
            halign: "center",
            cellWidth: 10,
          },
          1: {
            // columnWidth: 100,
          },
          2: {
            halign: "center",
            cellWidth: 20,
          },
          3: {
            halign: "center",
            cellWidth: 27,
          },
          4: {
            halign: "center",
            cellWidth: 23,
          },
        },
        styles: {
          lineWidth: 0.1, // Set the border line width
          lineColor: [0, 0, 0], // Set the border color
        },
        theme: "plain",
        body: rows,
        startY: 120,
      });

      const tableHeight = table.autoTable.previous.finalY;

      doc.text("Terms & Conditions", 15, tableHeight + 10);
      doc.text("Terms of Delivery", 15, tableHeight + 15);
      doc.text("Terms of Payment", 15, tableHeight + 20);
      doc.text("Validity", 15, tableHeight + 25);
      doc.text("Remarks", 15, tableHeight + 30);

      doc.text(":", 55, tableHeight + 15);
      doc.text(":", 55, tableHeight + 20);
      doc.text(":", 55, tableHeight + 25);
      doc.text(": ", 55, tableHeight + 30);

      doc.text(
        "a) Payment for completed services to be paid and made payable to",
        60,
        tableHeight + 30
      );
      doc.setFontStyle("bold");

      doc.text(
        "ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD.",
        60,
        tableHeight + 35
      );
      doc.setFontStyle("normal");
      doc.text(
        "b) All price(s) quoted is inclusive of Sales and Services Tax (SST), customs",
        60,
        tableHeight + 40
      );
      doc.text(
        "clerance or taxes and customs agent fees (if any).",
        60,
        tableHeight + 45
      );

      doc.text(
        this.deliveryterm + " " + this.deliverytermunit,
        60,
        tableHeight + 15
      );
      doc.text(this.paymentterm + " Days", 60, tableHeight + 20);
      doc.text(this.validity + " Days", 60, tableHeight + 25);
      var text = this.remarks;
      var x = 60;
      var y = tableHeight + 50;

      var lines = doc.splitTextToSize(
        text,
        doc.internal.pageSize.width - x * 1.3
      );

      if (this.remarks != "" && this.remarks != null) {
        doc.text("c) " + lines[0], x, y);
      }
      for (var i = 1; i < lines.length; i++) {
        if (y + 50 > doc.internal.pageSize.getHeight() - 20) {
          doc.addPage();
          y = 25;
        }
        doc.text(lines[i], x, y + 5);
        y += 5;
      }

      var finalYOfText = y;

      doc.text(
        "If you agree with the quotation, please sign in below and send/email it to us as attached as soon as",
        15,
        finalYOfText + 10
      );

      doc.text("possible for further arrangement.", 15, finalYOfText + 15);
      doc.text(
        "Should you need any clarification, please contact " +
        this.companyname +
        " at " +
        this.companyphoneno,
        15,
        finalYOfText + 20
      );
      doc.setFontStyle("bold");

      doc.text(
        "for ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD",
        15,
        finalYOfText + 30
      );
      doc.setFontStyle("normal");

      doc.text(
        "Previously known as DRB-HICOM ENVIRONMENTAL SERVICES SDN BHD",
        15,
        finalYOfText + 35
      );

      doc.setFontStyle("bold");

      doc.addImage(
        sign,
        "PNG",
        doc.internal.pageSize.getWidth() - 195,
        finalYOfText + 40,
        30,
        15
      );

      doc.text("NAZIRA MAHAYUDDIN", 15, finalYOfText + 60);

      doc.setFontStyle("normal");
      doc.text("Senior Manager,", 15, finalYOfText + 65);
      doc.text("Marine Waste Management,", 15, finalYOfText + 70);
      doc.text(
        "Environmental Technology & Solutions Department",
        15,
        finalYOfText + 75
      );

      //acknowledgement start here
      doc.addPage();
      doc.text("TO:", 15, 25);
      doc.setFontStyle("bold");
      doc.text("ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD", 15, 30);
      doc.text("MARINE WASTE MANAGEMENT, PORT RECEPTION FACILITIES", 15, 35);

      doc.setFontStyle("normal");
      doc.text("Attention : " + this.pic1pdf, 15, 45);
      // doc.text("Email : " + this.pic1nopdf, 100, 45);
      doc.text("Email : " + this.pic1emailpdf, 100, 45);

      doc.setFontStyle("bold");
      doc.text("ACKNOWLEDGEMENT / ACCEPTANCE OF OFFER", 60, 55);

      doc.setFontStyle("normal");
      doc.text(
        "I, .................................................................................................. as ................................................................",
        15,
        65
      );

      doc.setFontStyle("italic");

      doc.text("(Name)", 55, 70);
      doc.text("(Designation)", 145, 70);

      doc.setFontStyle("normal");

      doc.text(
        "Agreed to the quotation stated in the above mentioned letter ref no. " +
        this.jobno,
        15,
        80
      );
      doc.text(
        "dated " +
        moment().format("DD MMMM YYYY") +
        " and all terms and condition as mentioned.",
        15,
        85
      );

      doc.text("Thank you.", 15, 95);

      doc.text("Company Name", 15, 105);
      doc.text(
        ": ...............................................................................................................................",
        60,
        105
      );

      doc.text("Company Address", 15, 115);
      doc.text(
        ": ...............................................................................................................................",
        60,
        115
      );
      doc.text(
        ": ...............................................................................................................................",
        60,
        120
      );
      doc.text(
        ": ...............................................................................................................................",
        60,
        125
      );

      doc.text("Contact Person", 15, 135);
      doc.text(
        ": ...............................................................................................................................",
        60,
        135
      );

      doc.text("Designation", 15, 145);
      doc.text(
        ": ...............................................................................................................................",
        60,
        145
      );

      doc.text("Tel. No.", 15, 155);
      doc.text(
        ": ...............................................................................................................................",
        60,
        155
      );

      doc.text("Mobile No.", 15, 165);
      doc.text(
        ": ...............................................................................................................................",
        60,
        165
      );
      doc.text("Email Address", 15, 185);
      doc.text(
        ": ...............................................................................................................................",
        60,
        185
      );

      doc.text("Service to commence", 15, 195);
      doc.text(
        ": ...............................................................................................................................",
        60,
        195
      );

      const xx = 70;
      const xxx = 130;

      const yy = 199;
      const yyy = 209;

      const width = 8;
      const height = 8;

      // Draw the box
      doc.rect(xx, yy, width, height);

      doc.rect(xxx, yy, width, height);

      doc.rect(xx, yyy, width, height);

      doc.rect(xxx, yyy, width, height);

      doc.text("Contract Preferred", 15, 205);
      doc.text(":", 60, 205);
      doc.text("One off job", 80, 205);
      doc.text("*Two (2) years", 140, 205);

      doc.text("*One (1) year", 80, 215);
      doc.text("*Others, please specify", 140, 215);

      doc.setFontStyle("italic");
      doc.text(
        "I/We declare that the data provided is correct and accordingly. I/We also declare that all",
        15,
        225
      );
      doc.text(
        "individuals who are subject of any personal data provided therein have consented to my/our",
        15,
        230
      );
      doc.text(
        'disclosure of the personal data to Alam Flora Environmental Solutions Sdn Bhd ("AFES")',
        15,
        235
      );
      doc.text(
        "(Previously known as DRB-HICOM Environmental Services Sdn Bhd (“DHES”)) and the use",
        15,
        240
      );
      doc.text(
        "by AFES of the personal data in accordance with the policy on personal data attached herein.",
        15,
        245
      );

      doc.text(
        ".......................................................",
        15,
        265
      );
      doc.text("(Signature & Company's Stamp)", 16, 270);

      doc.text(".................................................", 120, 265);
      doc.text("(Date)", 140, 270);

      doc.save("Quotation.pdf");

      console.log("pdf createdd");
    },
    async createPDF() {
      await this.getPDF();
      this.duration = this.convertDays(this.validity);
      let doc = jsPDF({
        orientation: "potrait",
      });

      const logo = new Image();
      logo.src = require("@/assets/img/afesnew.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      const sign = new Image();
      sign.src = require("@/assets/img/autograph.png");
      sign.onload = () => {
        this.options = Object.assign({}, this.options, {
          sign: {
            sign,
          },
        });
      };

      const data = this.pdftable;

      const columns = [
        "No.",
        "\t\t\t\t\t\t\tDescription",
        "Unit Price (RM)",
        "Quantity",
      ];

      const rows = data.map((obj) => [
        obj.no,
        obj.desc,
        obj.rate,
        obj.estamt,
        obj.amt,
      ]);

      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      );

      doc.setFontSize(21);
      doc.setFontStyle("bold");
      doc.text("QUOTATION", 15, 25);
      doc.setFontSize(11);

      doc.setLineWidth(0.3);
      doc.line(10, 40, doc.internal.pageSize.getWidth() - 10, 40);

      doc.setFontStyle("bold");

      doc.text(this.companynamepdf, 15, 55);

      doc.setFontStyle("normal");

      var companyAddress = this.companyaddresspdf;
      var maxCharactersPerLine = 25;

      function splitTextIntoLines(text, maxLength) {
        var lines = [];
        while (text.length > maxLength) {
          var line = text.substring(0, maxLength);
          var lastSpace = line.lastIndexOf(" ");
          if (lastSpace !== -1) {
            lines.push(line.substring(0, lastSpace));
            text = text.substring(lastSpace + 1);
          } else {
            lines.push(line);
            text = text.substring(maxLength);
          }
        }
        lines.push(text);
        return lines;
      }

      var addressLines = splitTextIntoLines(
        companyAddress,
        maxCharactersPerLine
      );

      for (var i = 0; i < addressLines.length; i++) {
        var yPos = 60 + i * 5;
        doc.text(addressLines[i], 15, yPos);
      }

      doc.setFontStyle("bold");
      doc.text("Ref No.", 130, 55);
      doc.text("Date", 130, 60);
      doc.setFontStyle("normal");

      doc.text(":", 150, 55);
      doc.text(":", 150, 60);

      doc.text(this.jobno, 152, 55);
      doc.text(moment().format("DD-MM-YYYY"), 152, 60);

      doc.text("Tel No. : " + this.pic1nopdf, 15, 80);

      // doc.text("Email : -", 130, 80);
      doc.text("Email : " + this.pic1emailpdf, 130, 80);
      // doc.text(this.companyemailpdf, 85, 80);

      doc.setFontStyle("bold");

      doc.text("Attention", 15, 90);
      doc.text("Subject", 15, 95);

      doc.text(":", 35, 90);
      doc.text(":", 35, 95);

      doc.text(this.pic1pdf, 40, 90);
      doc.text(this.subject, 40, 95);

      doc.setFontStyle("normal");

      doc.text("Dear Sir/Madam,", 15, 105);
      doc.text(
        "We appreciate this opportunity to offer you our quotation as follows:",
        15,
        115
      );

      const table = doc.autoTable({
        head: [columns],
        columnStyles: {
          0: {
            halign: "center",
            cellWidth: 10,
          },
          1: {
            // columnWidth: 100,
          },
          2: {
            halign: "center",
            cellWidth: 30,
          },
          3: {
            halign: "center",
            cellWidth: 20,
          },
        },
        styles: {
          lineWidth: 0.1, // Set the border line width
          lineColor: [0, 0, 0], // Set the border color
        },
        theme: "plain",
        body: rows,
        startY: 120,
      });

      // let deliveryTermsTextPositionY = table.autoTable.previous.finalY + 10;

      // if (deliveryTermsTextPositionY > doc.internal.pageSize.getHeight() - 20) {
      //   doc.addPage();
      //   deliveryTermsTextPositionY = 20;
      // }

      const tableHeight = table.autoTable.previous.finalY;

      doc.text("Terms & Conditions", 15, tableHeight + 10);
      doc.text("Terms of Delivery", 15, tableHeight + 15);
      doc.text("Terms of Payment", 15, tableHeight + 20);
      doc.text("Validity", 15, tableHeight + 25);
      doc.text("Remarks", 15, tableHeight + 30);

      // doc.text(":", 55, tableHeight + 10);
      doc.text(":", 55, tableHeight + 15);
      doc.text(":", 55, tableHeight + 20);
      doc.text(":", 55, tableHeight + 25);
      doc.text(": ", 55, tableHeight + 30);

      doc.text(
        "a) Payment for completed services to be paid and made payable to",
        60,
        tableHeight + 30
      );
      doc.setFontStyle("bold");

      doc.text(
        "ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD.",
        60,
        tableHeight + 35
      );
      doc.setFontStyle("normal");
      doc.text(
        "b) All price(s) quoted is inclusive of Sales and Services Tax (SST), customs",
        60,
        tableHeight + 40
      );
      doc.text(
        "clerance or taxes and customs agent fees (if any).",
        60,
        tableHeight + 45
      );
      doc.text(
        "c) The invoiced quantity will be in accordance to the actual quantity",
        60,
        tableHeight + 50
      );
      doc.text(
        "collected and recorded in weigh bridge weight chit.",
        60,
        tableHeight + 55
      );
      // doc.text(
      //   "d)" + this.remark1,
      //   60,
      //   tableHeight + 60
      // );

      const ddate = "2024-06-21T08:09:16.236226Z";
      const validity = this.validity + " days";
      console.log(validity);
      // Parse the date using Moment.js
      const parsedDate = moment(ddate);

      // Add the validity period to the parsed date
      const endDate = parsedDate.clone().add(moment.duration(validity));

      // Calculate the difference in years, months, and days
      const diff = moment.duration(endDate.diff(parsedDate));
      const years = diff.years();
      const months = diff.months();
      const days = diff.days();

      // Format the result into a human-readable string
      let readableString = "";

      if (years > 0) {
        readableString += `${years} year${years > 1 ? "s" : ""}`;
      }

      if (months > 0) {
        if (readableString.length > 0) readableString += " ";
        readableString += `${months} month${months > 1 ? "s" : ""}`;
      }

      if (days > 0) {
        if (readableString.length > 0) readableString += " ";
        readableString += `${days} day${days > 1 ? "s" : ""}`;
      }

      readableString += ` (${parsedDate.format(
        "YYYY-MM-DD"
      )} - ${endDate.format("YYYY-MM-DD")})`;

      console.log(readableString);

      doc.text(
        this.deliveryterm + " " + this.deliverytermunit,
        60,
        tableHeight + 15
      );
      doc.text(this.paymentterm + " Days", 60, tableHeight + 20);
      doc.text(this.duration + " " + this.durationString, 60, tableHeight + 25); //kena kira kat sini
      var text = this.remark1;
      var x = 60;
      var y = tableHeight + 60;

      var lines = doc.splitTextToSize(
        text,
        doc.internal.pageSize.width - x * 1.3
      );

      if (this.remark1 != "" && this.remark1 != null) {
        doc.text("d) " + lines[0], x, y);
      }
      for (var i = 1; i < lines.length; i++) {
        if (y + 50 > doc.internal.pageSize.getHeight() - 20) {
          doc.addPage();
          y = 25;
        }
        doc.text(lines[i], x, y + 5);
        y += 5;
      }

      // let nextContentYPosition = table.autoTable.previous.finalY + y;

      // if (nextContentYPosition > doc.internal.pageSize.getHeight() - 20) {
      //   doc.addPage();
      //   nextContentYPosition = 20;
      // }

      var finalYOfText = y;

      doc.text(
        "If you agree with the quotation, please sign in below and send/email it to us as attached as soon as",
        15,
        finalYOfText + 10
      );

      doc.text("possible for further arrangement.", 15, finalYOfText + 15);
      doc.text(
        "Should you need any clarification, please contact " +
        this.pic1pdf +
        " at " +
        this.pic1nopdf,
        15,
        finalYOfText + 20
      );
      // doc.text(this.picname, 15, finalYOfText + 35);

      // doc.text("at", 95, finalYOfText + 35);

      // doc.text(this.picphoneno, 105, finalYOfText + 35);
      doc.setFontStyle("bold");

      doc.text(
        "for ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD",
        15,
        finalYOfText + 30
      );
      doc.setFontStyle("normal");

      doc.text(
        "Previously known as DRB-HICOM ENVIRONMENTAL SERVICES SDN BHD",
        15,
        finalYOfText + 35
      );

      doc.setFontStyle("bold");

      doc.addImage(
        sign,
        "PNG",
        doc.internal.pageSize.getWidth() - 195,
        finalYOfText + 40,
        30,
        15
      );

      doc.text("NAZIRA MAHAYUDDIN", 15, finalYOfText + 60);

      doc.setFontStyle("normal");
      doc.text("Senior Manager,", 15, finalYOfText + 65);
      doc.text("Marine Waste Management,", 15, finalYOfText + 70);
      doc.text(
        "Environmental Technology & Solutions Department",
        15,
        finalYOfText + 75
      );

      //acknowledgement start here
      doc.addPage();
      doc.text("TO:", 15, 25);
      doc.setFontStyle("bold");
      doc.text("ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD", 15, 30);
      doc.text("MARINE WASTE MANAGEMENT, PORT RECEPTION FACILITIES", 15, 35);

      doc.setFontStyle("normal");
      doc.text("Attention : " + this.pic1pdf, 15, 45);
      // doc.text("Email : " + this.pic1nopdf, 100, 45);
      doc.text("Email : " + this.pic1emailpdf, 100, 45);

      doc.setFontStyle("bold");
      doc.text("ACKNOWLEDGEMENT / ACCEPTANCE OF OFFER", 60, 55);

      doc.setFontStyle("normal");
      doc.text(
        "I, .................................................................................................. as ................................................................",
        15,
        65
      );

      doc.setFontStyle("italic");

      doc.text("(Name)", 55, 70);
      doc.text("(Designation)", 145, 70);

      doc.setFontStyle("normal");

      doc.text(
        "Agreed to the quotation stated in the above mentioned letter ref no. " +
        this.jobno,
        15,
        80
      );
      doc.text(
        "dated " +
        moment().format("DD MMMM YYYY") +
        " and all terms and condition as mentioned.",
        15,
        85
      );

      doc.text("Thank you.", 15, 95);

      doc.text("Company Name", 15, 105);
      doc.text(
        ": ...............................................................................................................................",
        60,
        105
      );

      doc.text("Company Address", 15, 115);
      doc.text(
        ": ...............................................................................................................................",
        60,
        115
      );
      doc.text(
        ": ...............................................................................................................................",
        60,
        120
      );
      doc.text(
        ": ...............................................................................................................................",
        60,
        125
      );

      doc.text("Contact Person", 15, 135);
      doc.text(
        ": ...............................................................................................................................",
        60,
        135
      );

      doc.text("Designation", 15, 145);
      doc.text(
        ": ...............................................................................................................................",
        60,
        145
      );

      doc.text("Tel. No.", 15, 155);
      doc.text(
        ": ...............................................................................................................................",
        60,
        155
      );

      doc.text("Mobile No.", 15, 165);
      doc.text(
        ": ...............................................................................................................................",
        60,
        165
      );
      doc.text("Email Address", 15, 185);
      doc.text(
        ": ...............................................................................................................................",
        60,
        185
      );

      doc.text("Service to commence", 15, 195);
      doc.text(
        ": ...............................................................................................................................",
        60,
        195
      );

      const xx = 70;
      const xxx = 130;

      const yy = 199;
      const yyy = 209;

      const width = 8;
      const height = 8;

      // Draw the box
      doc.rect(xx, yy, width, height);

      doc.rect(xxx, yy, width, height);

      doc.rect(xx, yyy, width, height);

      doc.rect(xxx, yyy, width, height);

      doc.text("Contract Preferred", 15, 205);
      doc.text(":", 60, 205);
      doc.text("One off job", 80, 205);
      doc.text("*Two (2) years", 140, 205);

      doc.text("*One (1) year", 80, 215);
      doc.text("*Others, please specify", 140, 215);

      doc.setFontStyle("italic");
      doc.text(
        "I/We declare that the data provided is correct and accordingly. I/We also declare that all",
        15,
        225
      );
      doc.text(
        "individuals who are subject of any personal data provided therein have consented to my/our",
        15,
        230
      );
      doc.text(
        'disclosure of the personal data to Alam Flora Environmental Solutions Sdn Bhd ("AFES")',
        15,
        235
      );
      doc.text(
        "(Previously known as DRB-HICOM Environmental Services Sdn Bhd (“DHES”)) and the use",
        15,
        240
      );
      doc.text(
        "by AFES of the personal data in accordance with the policy on personal data attached herein.",
        15,
        245
      );

      doc.text(
        ".......................................................",
        15,
        265
      );
      doc.text("(Signature & Company's Stamp)", 16, 270);

      doc.text(".................................................", 120, 265);
      doc.text("(Date)", 140, 270);

      // doc.text("Created by " + this.pic1pdf, 15, finalYOfText + 80);
      if (this.jobno.startsWith("V")) {
        doc.save("ANF Quotation.pdf");
      } else if (this.jobno.startsWith("L")) {
        doc.save("WCO Quotation.pdf");
      } else {
        doc.save("Quotation.pdf");
      }

      console.log("pdf createdd");
    },
    getStatus() {
      this.selects.statuses = [];

      this.$http.get(":10001/api/v1/status/sale").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].status,
              value: response[i].value,
            };
            this.selects.statuses.push(obj);
          }
        }
      });

      this.selects.status = 0;
    },
    onFileChangeDisputedocsManagement(event) {
      this.uploadload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.quotitle = filesArray.map(file => file.name).join(', ');

        const uploadPromises = [];

        this.uploadload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http.post(
            ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/quotation-dispute-document",
            formData,
            {
              headers: {
                Authorization: `Bearer ${getStorage("token")}`,
                "Content-Type": "multipart/form-data",
              },
            }
          ).then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log('why')
              setTimeout(() => {
                this.getRowData(this.currentsaleid, '');
              }, 1000);
              this.message = response;
            } else {
              console.log("data tak masuk");
              swal({
                title: "Data Error!",
                text: `${res.message}`,
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }
          }).catch((error) => {
            console.error("Upload failed:", error);
          });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises).then(() => {
          this.modals.successModal = true;
          this.btnsubmit = false;
          t.value = "";

        }).catch((error) => {
          console.error("One or more uploads failed:", error);
        }).finally(() => {
          this.uploadload = false;
          this.buttondisabled = false;
        });
      } else {
        this.quotitle = "";
      }
    },

    removeDisputedocsManagement(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/quotation-dispute-document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getRowData(this.currentsaleid, '');
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    disputeQuotation() {
      if (this.reason != "") {
        let obj = {
          remark: this.reason,
        };

        this.$http
          .put(
            ":10001/api/v1/shop/quote/" +
            this.currentsaleid +
            "/quotation/dispute",
            obj
          )
          .then((res) => {
            if (!res.error) {
              swal({
                title: `Success!`,
                text: "Quotation dispution success.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-primary btn-fill",
                type: "success",
              }).then((result) => {
                console.log(result);
                if (result.value) {
                  this.modals.disputereason = false;
                }
              });
            } else {
              console.log("quote not approve", response);
            }
          })
          .catch((err) => {
            swal({
              title: `Error!`,
              text: "Quotation dispution failed.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-cancel btn-fill",
              type: "error",
            });
          });
      } else {
        swal({
          title: `Info!`,
          text: "Please fill in the reason",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "warning",
        });
      }
    },

    acceptQuotation() {
      this.$http
        .put(
          ":10001/api/v1/shop/quote/" + this.currentsaleid + "/quotation/accept"
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Quotation acceptance success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.modals.viewquotation = false;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
          } else {
            console.log("quote not approve", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Quotation acceptance failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    completeDeliveryOrder() {
      this.$http
        .post(":10001/api/v1/shop/quote/" + this.currentsaleid + "/complete")
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Completion success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.modals.viewdeliveryorder = false;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
          } else {
            console.log("quote not approve", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Completion failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    submitProforma() {
      this.$http
        .post(
          ":10001/api/v1/shop/quote/" +
          this.currentsaleid +
          "/document/invoice-document/submit"
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Submission success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.modals.viewproforma = false;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
          } else {
            console.log("quote not approve", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Submission failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    removeProof(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/shop/quote/" +
              this.currentsaleid +
              "/document/invoice-document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getRowData(this.currentsaleid, "");
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    onFileChangeProof(event) {
      this.uploadload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.quotitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.uploadload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/shop/quote/" +
              this.currentsaleid +
              "/document/invoice-document",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log("why");
                setTimeout(() => {
                  this.getRowData(this.currentsaleid, "");
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.uploadload = false;
            this.buttondisabled = false;
          });
      } else {
        this.quotitle = "";
      }
    },

    removeQuoDoc(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/shop/quote/" +
              this.currentsaleid +
              "/document/accept-quotation/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getRowData(this.currentsaleid, "");
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    onFileChangeQuoDoc(event) {
      this.quoload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.quotitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.quoload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/shop/quote/" +
              this.currentsaleid +
              "/document/accept-quotation",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                setTimeout(() => {
                  this.getRowData(this.currentsaleid);
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.quoload = false;
            this.buttondisabled = false;
          });
      } else {
        this.quotitle = "";
      }
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },

    clickRow(row) {
      this.getRowData(row.saleid, row.statusid);

      this.currentsaleid = row.saleid;
      this.currentstatus = row.statusid;

      if (row.statusid == 3) {
        this.modals.viewquotation = true;
      } else if (row.statusid == 6) {
        this.modals.viewproforma = true;
      } else if (row.statusid == 7 || row.statusid == 8 || row.statusid == 100) {
        this.modals.viewdeliveryorder = true;
      } else {
        this.modals.viewother = true;
      }
    },
    rowHover(row) {
      const status = row.status;
      // if (status === 'Review Quotation' || status === 'Ready for pickup' || status === 'Proforma Invoice Ready') {
      //   return 'hover-row';
      // }
      return "hover-row";
    },
    getDisputeReason(row, flag) {
      if (flag === "quo") {
        this.reason = row.disputereason;
        this.modals.viewrejectreason = true;
      } else if (flag === "job") {
        this.reason = row.jobdisputereason;
        this.modals.viewrejectreason = true;
      }
    },
    camelCase(str) {
      if (str !== "") {
        let splitStr = str.toLowerCase().split(" ");
        for (let i = 0; i < splitStr.length; i++) {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(" ");
      }
      return str;
    },

    getReview(data) {
      this.jobnum = data.refno;
      this.$router.push("/Land/Review/" + this.jobnum);
    },

    getReferenceNo() {
      this.$http.get(":10001/api/v1/incoming/generate").then((res) => {
        if (!res.error) {
          let response = res.message;

          this.referenceno = response.reference_no;
          this.wastejobid = response.waste_job_id;

          this.$router.push("/Land/RequestJob/" + this.referenceno + "/add");
        }
      });
    },

    getJobPage(data) {
      this.jobnum = data.refno;
      if (data.status.toUpperCase() === "DRAFT") {
        this.$router.push("/Land/RequestJob/" + this.jobnum + "/edit");
      } else {
        this.$router.push("/Land/RequestJob/" + this.jobnum + "/view");
      }
    },

    getRowData(saleid, status) {
      this.allorderitems = [];
      this.allquotationdocs = [];
      this.allpaymentproof = [];
      this.allproformafile = [];
      this.alldisputedocsmanage = [];
      this.allquotedisputedocs = [];
      this.logquotationdisputed = [];

      this.$http.get(":10001/api/v1/shop/quote/" + saleid).then((res) => {
        if (!res.error) {
          let response = res.message;

          if (response.issued_by != null) {
            this.companyname = response.issued_by.user_name;
            this.companyphoneno = response.issued_by.phone_number;
          }

          if (response.address != null)
            this.companyaddress = response.address.line_1 + "" + response.address.line_2 + "," + response.address.city + ", " + response.address.postcode + "," + response.address.state + ", Malaysia.";
          if (response.address == null)
            this.companyaddress = 'Self-pickup'
          this.transportrate = response.transport_rate == null ? parseFloat(0).toFixed(2) : parseFloat(response.transport_rate).toFixed(2),
            this.statusname = response.status.name;
          this.pagestatus = response.status.status;

          this.referenceno =
            response.reference_number == null || response.reference_number == ""
              ? "-"
              : response.reference_number;
          this.subjectline =
            response.subject_line == null ? "-" : response.subject_line;
          // this.customer = response.subject_line == null ? '-' : response.subject_line;
          if (response.pic != null) {
            this.picname =
              response.pic.user_name == null ? "-" : response.pic.user_name;
            this.picphoneno =
              response.pic.phone_number == null
                ? "-"
                : response.pic.phone_number;
          }
          if (response.service_location != null)
            this.servicelocation =
              response.service_location.location == null
                ? "-"
                : response.service_location.location;
          this.customerremark =
            response.customer_remark == null || response.customer_remark == "" ? "-" : response.customer_remark;
          this.deliveryterm =
            response.delivery_term == null ? "-" : response.delivery_term;
          this.deliverytermunit =
            response.delivery_term_unit == null
              ? "-"
              : response.delivery_term_unit;
          this.paymentterm =
            response.payment_term == null ? "-" : response.payment_term;
          this.validity = response.validity == null ? "-" : response.validity;
          this.remarks = response.remark == null ? "-" : response.remark;

          if (response.dispute_reason != null)
            this.quotedisputedreason = response.dispute_reason;

          if (response.dispute_reason == null && response.dispute_log != null && response.dispute_log.length > 0) {
            let latestlog = response.dispute_log[response.dispute_log.length - 1];

            this.quotationdisputedreason = (latestlog.remark == null || latestlog.remark.trim() === '') ? '-' : latestlog.remark;
          }

          if (response.order_ready_by != null)
            this.proposedate = response.order_ready_by;

          if (response.order_ready_at != null)
            this.pickuplocation = response.order_ready_at;

          var totalamount = 0;
          for (let i = 0; i < response.order.length; i++) {
            let wastetype = {
              wastetypeid: response.order[i].waste_type.waste_type_id,
              name: response.order[i].waste_type.name,
            };

            let obj = {
              indexing: i + 1,
              orderid: response.order[i].sale_quotation_id,
              quantity: response.order[i].quantity,
              remark: response.order[i].remark,
              waste_type: wastetype,
              rate: parseFloat(response.order[i].rate).toFixed(2),
              ratecent: parseFloat(response.order[i].rate_cent).toFixed(2),
              amount: (
                parseFloat(response.order[i].quantity) *
                parseFloat(response.order[i].rate)
              ).toFixed(2),
            };
            var amount = response.order[i].quantity * response.order[i].rate;
            totalamount += amount;
            this.allorderitems.push(obj);
          }
          let transportrate = {
            wastetypeid: 0,
            name: 'Transportation rate',
          }
          let grandtotal = {
            wastetypeid: 0,
            name: 'GRAND TOTAL',
          }
          if (status == 3 || status == 100 || status == 7 || status == 8) {
            this.allorderitems.push(
              {
                amount: totalamount,
                waste_type: transportrate,
              }
            );
            this.allorderitems.push(
              {
                amount: (parseFloat(totalamount) + parseFloat(this.transportrate)).toFixed(2),
                waste_type: grandtotal,
              }
            );
          } else
            this.allorderitems.push(
              {
              }
            )

          if (response.quotation_document != null)
            for (var i = 0; i < response.quotation_document.length; i++) {
              let obj = {
                filename: response.quotation_document[i].meta.filename,
                fileurl: response.quotation_document[i].url,
                fileid: response.quotation_document[i].document_id,
              };
              this.allquotationdocs.push(obj);
            }

          //get quo docs
          if (response.invoice_document != null)
            for (var i = 0; i < response.invoice_document.length; i++) {
              let obj = {
                filename: response.invoice_document[i].meta.filename,
                fileurl: response.invoice_document[i].url,
                fileid: response.invoice_document[i].document_id,
              };
              this.allpaymentproof.push(obj);
            }

          if (response.performa_invoice_document != null)
            for (
              var i = 0;
              i < response.performa_invoice_document.length;
              i++
            ) {
              let obj = {
                filename: response.performa_invoice_document[i].meta.filename,
                fileurl: response.performa_invoice_document[i].url,
                fileid: response.performa_invoice_document[i].document_id,
              };
              this.allproformafile.push(obj);
            }

          if (response.quotation_dispute_document != null)
            for (
              var i = 0;
              i < response.quotation_dispute_document.length;
              i++
            ) {
              let obj = {
                filename: response.quotation_dispute_document[i].meta.filename,
                fileurl: response.quotation_dispute_document[i].url,
                fileid: response.quotation_dispute_document[i].document_id,
              };
              this.alldisputedocsmanage.push(obj);
            }

          if (response.dispute_document != null)
            for (
              var i = 0;
              i < response.dispute_document.length;
              i++
            ) {
              let obj = {
                filename: response.dispute_document[i].meta.filename,
                fileurl: response.dispute_document[i].url,
                fileid: response.dispute_document[i].document_id,
              };
              this.allquotedisputedocs.push(obj);
            }

          if (response.dispute_log != null)
            for (
              var i = 0;
              i < response.dispute_log.length;
              i++
            ) {
              let obj = {
                remark: response.dispute_log[i].remark == null || response.dispute_log[i].remark == '' ? '-' : response.dispute_log[i].remark,
                date: moment(response.dispute_log[i].created_at).format("DD-MM-YYYY"), // adjust format
                username: response.dispute_log[i].user.user_name,
              };
              this.logquotationdisputed.push(obj);
            }
        }
      });
    },

    getData() {
      this.load = true;
      this.tableDatas = [];
      this.temp = [];

      var path = '';
      if (this.search == undefined || this.search == '') {
        path = ':10001/api/v1/shop/quote?size=' + this.pagination.perPage + '&page=' + this.pagination.currentPage + '&status=' + this.selects.status;
      } else {
        path = ':10001/api/v1/shop/quote?size=' + this.pagination.perPage + '&filters=[["reference_number","ilike","' + this.search + '"],["company.company_name", "ilike", "' + this.search + '"]]&page=' + this.pagination.currentPage + '&status=' + this.selects.status
      }


      this.$http.get(path).then((res) => {
        if (!res.error) {
          this.pagination.total = res.message.total;

          let response = res.message.items;


          for (let i = 0; i < response.length; i++) {
            let obj = {
              index: (i + 1) + (this.pagination.perPage * (this.pagination.currentPage - 1)),
              saleid: response[i].sale_quotation_id,
              picname: response[i].pic.user_name,
              refno:
                response[i].reference_number == null ||
                  response[i].reference_number == ""
                  ? "-"
                  : response[i].reference_number,
              // requestdate: moment(response[i].created_at).format("DD-MM-YYYY"),
              requestdate: response[i].created_at,
              deliverytype: response[i].delivery_type.name,
              status: this.camelCase(response[i].status.name),
              statuscolour: response[i].status.status_color,
              statusid: response[i].status.status,
              remarks: response[i].customer_remark || "",
            };
            this.tableDatas.push(obj);
            this.temp.push(obj);
          }

          this.load = false;
        }
      });
    },
    gobrowse() {
      this.$router.push("/Land/BrowseProduct");
    },

    getDeleteRow(index) {
      this.tableDatas.splice(index, 1);
    },
  },
  created() {
    this.getStatus();
    this.getData();

    this.roleid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1])).role_id
    );

    if (this.roleid == 2) {
      this.path = "Land";
    } else if (this.roleid == 3) {
      this.path = "Vessel";
    }
  },
  computed: {
    cansubmit() {
      return this.allpaymentproof.length === 0;
    },
    candispute() {
      return this.reason === "";
    },
    canreject() {
      return this.newdate === "";
    },
    canapprove() {
      return this.allquotationdocs.length === 0;
    },
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    // to() {
    //   let highBound = this.from + this.pagination.perPage;
    //   if (this.total < highBound) {
    //     highBound = this.total;
    //   }
    //   return highBound;
    // },
    // from() {
    //   return this.pagination.perPage * (this.pagination.currentPage - 1);
    // },
    // total() {
    //   return this.searchedData.length > 0
    //     ? this.searchedData.length
    //     : this.tableDatas.length;
    // },
  },
  watch: {
    "search"() {
      this.getData();
    },
    searchQuery: debounce(function (search) {
      if (search !== "") {
        this.tableDatas = this.temp.filter(
          (value) =>
            value.refno.toLowerCase().includes(search.toLowerCase()) ||
            value.picname.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.tableDatas = this.temp;
      }
    }, 500),
    "pagination.currentPage"() {
      this.getData();
    },
    "pagination.perPage"() {
      this.getData();
    },
    "pagination.total"() {
      console.log(this.pagination)
      console.log("pagination : ", this.pagination.total)
    },
  },
  mounted() {
    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["refno"],
      threshold: 1.0,
    });
  },
};
</script>

<style>
.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.custom-dropdown .el-select-dropdown {
  background-color: blue;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.job-no-title {
  color: #358CCB;
  text-decoration: none;
}

.job-no-title:hover {
  color: #358CCB;
  text-decoration: underline;
  cursor: pointer;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.job-no-title2 {
  color: #A5A5A5;
  text-decoration: none;
}

.job-no-title2:hover {
  color: #A5A5A5;
  text-decoration: underline;
  cursor: pointer;
}

textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.hover-row {
  cursor: pointer;
}

.nothover-row {
  /* cursor: normal; */
}

.card .card-header {
  text-align: center;
}

.newtitle {
  color: #707070 !important;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-title {
  margin-top: -5px;
  color: #A5A5A5 !important;
}

.statusview {
  cursor: pointer;
}

.statusview:hover {
  text-decoration: underline;
}
</style>
